module.exports = __webpack_public_path__ + "static/media/home_page.4766623b.gif";